import { render, staticRenderFns } from "./TaxSalary.vue?vue&type=template&id=20dd5b82&scoped=true"
import script from "./TaxSalary.vue?vue&type=script&lang=js"
export * from "./TaxSalary.vue?vue&type=script&lang=js"
import style0 from "./TaxSalary.vue?vue&type=style&index=0&id=20dd5b82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dd5b82",
  null
  
)

export default component.exports